import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import Settings from 'pages/Settings';
import InvoicePrefix from 'pages/Settings/IdentifierChars';
import TaxTypes from 'pages/Settings/TaxTypes';
import SaleTypes from 'pages/Settings/SalesTypes';
import MeasurementUnits from 'pages/Settings/MeasurementUnits';
import PaymentMethods from 'pages/Settings/PaymentMethods';
import DefaultLang from 'pages/Settings/DefaultLanguage';

import PrivateRoute from '../hoc/PrivateRoute';

export const settingsRoutes: RouteObject[] = [
  {
    path: '/settings',
    element: (
      <PrivateRoute>
        <Settings />
      </PrivateRoute>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="invoice-chars" />,
      },
      {
        path: 'invoice-chars',
        element: <InvoicePrefix />,
      },
      {
        path: 'tax-types',
        element: <TaxTypes />,
      },
      {
        path: 'sales-types',
        element: <SaleTypes />,
      },
      {
        path: 'payment-methods',
        element: <PaymentMethods />,
      },
      {
        path: 'measurement-units',
        element: <MeasurementUnits />,
      },
      {
        path: 'default-language',
        element: <DefaultLang />,
      },
    ],
  },
];
